(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('almica-photo-tabs')){
customElements.define('almica-photo-tabs',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;
this.dataset.ready='true';
const tabs=Array.from(this.querySelectorAll('[role="tab"]'));
const panels=Array.from(this.querySelectorAll('[role="tabpanel"]'));
this.querySelector('[role="tablist"]').hidden=false;
const select=index=>{
tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
if(index===1)this.querySelectorAll('video').forEach(video=>video.pause());
window.dispatchEvent(new Event('resize'));
};
tabs.forEach((tab,index)=>{
tab.addEventListener('click',()=>select(index));
tab.addEventListener('keydown',event=>{
let next;
if(event.key==='ArrowRight')next=(index+1)%tabs.length;
if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
if(event.key==='Home')next=0;
if(event.key==='End')next=tabs.length-1;
if(next!==undefined){event.preventDefault();select(next);tabs[next].focus();}
});
});
}
});
}
  } catch(e) { console.error(e); }
})();

})();
